"use client";

import { usePricelist } from "@/pricelist/PricelistContext";
import { getMemberPriceOffer, type PriceList } from "@/products/pricing";

/** The member price of a product for the current user, see getMemberPriceOffer */
export function useMemberPriceOffer({
  originalItemPrice,
  subjectToVAT,
  pricelists,
}: {
  originalItemPrice: number | null | undefined;
  subjectToVAT: boolean | null | undefined;
  pricelists?: PriceList[] | null | undefined;
}) {
  const { applicablePricelists } = usePricelist();

  const identifiers = (onlyMemberships: boolean) =>
    new Set(
      applicablePricelists
        .filter(
          ({ node }) =>
            !onlyMemberships ||
            Boolean(node?.targetAudience?.customerGroupIdentifiers?.length),
        )
        .map(({ node }) => node?.identifier)
        .filter((identifier): identifier is string => Boolean(identifier)),
    );

  return getMemberPriceOffer({
    originalItemPrice,
    subjectToVAT,
    priceLists: pricelists,
    applicableIdentifiers: identifiers(false),
    memberIdentifiers: identifiers(true),
  });
}
